import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, from, switchMap, catchError } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class CognitoHeaderInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Only intercept Medmio API requests. Everything else (asset fetches,
    // Cognito SDK calls to AWS, etc.) passes through unchanged.
    if (!request.url.startsWith(environment.apiUrlBase())) {
      return next.handle(request);
    }

    // Defensive Sprint 6 pattern: try Amplify session first, regardless of
    // the `useCognito` feature flag. The flag was previously a hard gate
    // here, but Sprint 6 surfaced cases where the flag was read as false
    // even when a valid Cognito session existed -- API calls then went
    // out unauthenticated and the backend returned 401, leaving the
    // sidebar / roles unpopulated. If Amplify has no session, fall
    // through cleanly to `next.handle(request)` so OAuthModule's
    // Duende interceptor (auto-installed via `sendAccessToken: true` in
    // OAuthModule.forRoot) attaches the Duende bearer.
    return from(fetchAuthSession({ forceRefresh: false })).pipe(
      switchMap((session) => {
        const token = session.tokens?.accessToken?.toString();
        if (!token) return next.handle(request);
        return next.handle(
          request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
        );
      }),
      catchError(() => next.handle(request)),
    );
  }
}
